import { render } from "./CustomerDetails.vue?vue&type=template&id=c5a07b58&scoped=true&ts=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts"

import "./CustomerDetails.vue?vue&type=style&index=0&id=c5a07b58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5a07b58"]])

export default __exports__